import { render, staticRenderFns } from "./flow_notes.vue?vue&type=template&id=0be0c4a7&scoped=true&"
import script from "./flow_notes.vue?vue&type=script&lang=js&"
export * from "./flow_notes.vue?vue&type=script&lang=js&"
import style0 from "./flow_notes.vue?vue&type=style&index=0&id=0be0c4a7&scoped=true&lang=css&"
import style1 from "./flow_notes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0c4a7",
  null
  
)

export default component.exports